import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import useSeoTags from '../hooks/useSeoTags';

const SeoTags = () => {
    const { pathname } = useLocation();
    const { canonical, robots, title, description } = useSeoTags(pathname);

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            {canonical && <link rel="canonical" href={canonical} />}
            {robots && <meta name="robots" content={robots} />}
        </Helmet>
    );
};

export default SeoTags;
